export default __webpack_public_path__ + "static/media/wireless-bluetooth-4.0bc2cf99.png";